import api from 'services/system/forgot-password'
import { history } from 'utils/history'

export const handleUpdatePassword = async (values: any) => {
  if (await api.updatePassword(values)) history.push('/')
}
